import React, { useState, useEffect, useContext, useRef } from 'react';
import Moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import DayGridPlugin from '@fullcalendar/daygrid';
import TimeGridPlugin from '@fullcalendar/timegrid';
import InteractionPlugin from '@fullcalendar/interaction';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as COM from '.';
import { AuthContext } from '../../containers/App';

export const DatasetCalendar = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [value, setValue] = useState(Moment());
  const [view, setView] = useState(props.defaultView ? props.defaultView : 'dayGridWeek');
  const auth = useContext(AuthContext);
  const calendarRef = useRef();

  const loadData = async (date = Moment()) => {
    let data = await COM.fetchData({
      connector: props.connector,
      dataset: props.dataset,
      filters: {
        year: {
          "$in": [date.clone().startOf('week').year(), date.clone().endOf('week').year()]
        },
        month: {
          "$in": [date.clone().startOf('week').month() + 1, date.clone().endOf('week').month() + 1]
        }
      },
    }, auth);
    setData(data);
  }

  const init = async () => {
    setLoading(true);
    await loadData(value);
    setLoading(false);
  }

  useEffect(() => {
    if (props.initDate) {
      calendarRef.current.getApi().gotoDate(props.initDate.toDate());
      init(props.initDate);
    } else {
      init();
    }
  }, []);

  return (
    <Antd.Spin
      spinning={loading}
    >
      <Antd.Space>
        <Antd.Button.Group>
          <Antd.Button
            onClick={(value) => {
              calendarRef.current.getApi().prev();
              let date = Moment(calendarRef.current.getApi().getDate());
              // console.log(Moment(date));
              setLoading(true);
              setValue(date);
              loadData(date);
              setLoading(false);
            }}
          >
            <AntdIcons.LeftOutlined />
          </Antd.Button>
          <Antd.Button
            onClick={(value) => {
              calendarRef.current.getApi().next();
              let date = Moment(calendarRef.current.getApi().getDate());
              setLoading(true);
              setValue(date);
              loadData(date);
              setLoading(false);
            }}
          >
            <AntdIcons.RightOutlined />
          </Antd.Button>
        </Antd.Button.Group>
        <Antd.DatePicker
          placeholder="Go to"
          allowClear={false}
          onChange={(value) => {
            setLoading(true);
            setValue(value);
            calendarRef.current.getApi().gotoDate(value.toDate());
            loadData(value);
            setLoading(false);
          }}
        />
        <Antd.Select
          style={{
            width: 150
          }}
          defaultValue={view}
          onChange={(value) => {
            setLoading(true);
            setView(value);
            calendarRef.current.getApi().changeView(value);
            setLoading(false);
          }}
        >
          <Antd.Select.Option value="dayGridWeek">Week</Antd.Select.Option>
          <Antd.Select.Option value="dayGridMonth">Month</Antd.Select.Option>
        </Antd.Select>
        <Antd.Typography.Title
          level={5}
          style={{
            marginTop: 5
          }}
        >
          {calendarRef.current ? Moment(calendarRef.current.getApi().getDate()).format('MM/YYYY') : null}
        </Antd.Typography.Title>
      </Antd.Space>
      {props.extra
        && props.extra.length > 0
        ? <Antd.Space
          style={{
            float: 'right'
          }}>
          {props.extra
            ? props.extra.map(child => child)
            : null}
        </Antd.Space>
        : null}
      <FullCalendar
        ref={calendarRef}
        height={700}
        plugins={[DayGridPlugin, TimeGridPlugin, InteractionPlugin]}
        initialView={view}
        displayEventEnd={true}
        weekNumbers={true}
        headerToolbar={{
          left: '',
          right: '',
        }}
        slotLabelFormat={{
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: false,
          hour12: false,
        }}
        eventTimeFormat={{
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false,
          hour12: false,
        }}
        // events={data.map(child => ({ title: child.title, start: child.start, end: child.end }))}
        events={data}
        // selectable={true}
        // select={(info) => {
        //   console.log(info)
        // }}                
        // firstDay={1}
        // weekends={true}
        {...props}
      />
    </Antd.Spin>
  );
};